import React from 'react';
import "../../styles/unknown/page_not_found.css";
import NotFoundImage from "../../images/unknown/glitch-error-404-page-background.png";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth } from "../firebase/firebase_configuration";
import { Link } from "react-router-dom";
import { useSearchContext } from "../chats/searchContext";

const PageNotFound = () => {
    const {setUnknownTab} = useSearchContext();
    const [getUserId, setUserId] = useState("");

    useEffect(() => {
        setUnknownTab("unknown");
        // throw new Error("yegs");
    }, [setUnknownTab]);

    useEffect (() => {
        const isLoggedIn = onAuthStateChanged(firebaseAuth, (user) => {
          if (user) {
            setUserId(user.uid);
          }
        });
    
        return () => isLoggedIn();
    }, []);

    return(
        <div className="page_not_found_screen">
            <img alt='Unknown Page' className="page_not_found_screen_image" src={NotFoundImage} />
            <Link onClick={() => setUnknownTab("")} to={getUserId === "" || getUserId == null ? "/login" : "/main_back/home"} className="page_not_found_screen_link"><p className="page_not_found_screen_link_text">{getUserId === "" || getUserId == null ? "Go to the Login Page" : "Go to the Home Page"}</p></Link>
        </div>
    );
};

export default PageNotFound;